/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
    active: PropTypes.bool,
    inline: PropTypes.bool,
    inner: PropTypes.bool,
    link: PropTypes.bool,
};

const defaultProps = {
    ...commonDefaultProps,
    active: false,
    componentClass: 'li',
    inline: false,
    inner: false,
    link: false,
};

const ListItem = (props) => {
    const classNames = [
        'c-list__item',
        props.active ? 'c-list__item--active' : '',
        props.inline ? 'c-list__item--inline' : '',
        props.inner ? 'c-list__item--inner' : '',
        props.link ? 'c-list__item--link' : '',
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    return (
        <props.componentClass
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        >
            {props.children}
        </props.componentClass>
    );
};

ListItem.propTypes = propTypes;

ListItem.defaultProps = defaultProps;

export default ListItem;
